import {
  CurrencyPipe,
  DatePipe,
  TitleCasePipe,
  registerLocaleData,
} from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
//LOCALE BR
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { AuthService } from './services/vos/auth.service';
import { CepService } from './services/vos/cep.service';
import { SharedModule } from './shared/shared.module';
registerLocaleData(ptBr);

import {
  LY_THEME,
  LY_THEME_NAME,
  LyHammerGestureConfig,
  LyTheme2,
  StyleRenderer,
} from '@alyle/ui';

import { LyButtonModule } from '@alyle/ui/button';
import { LyDialogModule } from '@alyle/ui/dialog';
import { LyIconModule } from '@alyle/ui/icon';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LySliderModule } from '@alyle/ui/slider';
import { MinimaDark, MinimaLight } from '@alyle/ui/themes/minima';
import { MatStepperModule } from '@angular/material/stepper';
import {
  NgbAlertModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ModalNotificacaoComponent } from './administrador/notificacao/modal-notificacao/modal-notificacao.component';
import { AuthInterceptorInterceptor } from './auth-interceptor.interceptor';
import { NavMobileComponent } from './main/nav-mobile/nav-mobile.component';
import { MeuPerfilModule } from './meu-perfil/meu-perfil.module';
import { RelatorioPrestadorModule } from './operacao/relatorio-prestador/relatorio-prestador.module';

@NgModule({
  declarations: [AppComponent, MainComponent, NavMobileComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    LyImageCropperModule,
    LySliderModule,
    LyButtonModule,
    LyIconModule,
    LyDialogModule,
    NgbPaginationModule,
    NgbAlertModule,
    MatStepperModule,
    RelatorioPrestadorModule,
    MeuPerfilModule,
  ],
  providers: [
    AuthService,
    { provide: LOCALE_ID, useValue: 'pt' },
    CepService,
    LyTheme2,
    StyleRenderer,
    // Theme that will be applied to this module
    { provide: LY_THEME_NAME, useValue: 'minima-light' },
    { provide: LY_THEME, useClass: MinimaLight, multi: true }, // name: `minima-light`
    { provide: LY_THEME, useClass: MinimaDark, multi: true }, // name: `minima-dark`
    { provide: HAMMER_GESTURE_CONFIG, useClass: LyHammerGestureConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorInterceptor,
      multi: true,
    },
    CurrencyPipe,
    TitleCasePipe,
    DatePipe,
  ],
  entryComponents: [ModalNotificacaoComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
